function getDomain() {
    let hostname = window.location.hostname;
    return hostname === "localhost"
        ? "osrit"
        : hostname.split(".").slice(2, 1)[0];
}

const defaultState = {
    authBusy: false,
    isQaOnly: !window.location.hostname.includes("compliance.osrit"),
    baseUrl: "https://osritapi.com/api",
    documentUrl: `https://agreements.${getDomain()}.com`
};

export default function app(state = defaultState, action) {
    switch (action.type) {
        default:
            return state;
    }
}
